import { render } from "./TestScript.vue?vue&type=template&id=32c633e3"
import script from "./TestScript.vue?vue&type=script&lang=js"
export * from "./TestScript.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__